import { render } from "./feedback_form.vue?vue&type=template&id=0386705c&scoped=true"
import script from "./feedback_form.vue?vue&type=script&lang=js"
export * from "./feedback_form.vue?vue&type=script&lang=js"

import "./feedback_form.vue?vue&type=style&index=0&id=0386705c&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0386705c"]])

export default __exports__